import {DataFetcher} from '@aboutyou/data-fetcher';
import {SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';
import {USP_BANNER_HEIGHT} from '../constants';
import {useUSPSection} from '../hooks/useGetHeaderBulkSection';
import {UspBannerView} from './UspBannerView';

export const UspBanner: React.FC = () => (
  <DataFetcher
    request={useUSPSection()}
    Loading={Skeleton}
    View={UspBannerView}
    Error={() => null}
  />
);

const Skeleton = () => {
  return <SkeletonBlock $height={`${USP_BANNER_HEIGHT}px`} />;
};
